import { render, staticRenderFns } from "./Searchform.vue?vue&type=template&id=285d7e00&"
import script from "./Searchform.vue?vue&type=script&lang=js&"
export * from "./Searchform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports